import {Routes} from "@angular/router";
import {AnalyticsRouting} from "./common/routes/analytics-routing";
import {
  EventSelectorViewComponent
} from "./single-event-analysis/views/event-selector-view/event-selector-view.component";
import {AuthGuard} from "../../_auth/auth.guard";
import {PermissionService} from "../../_auth/permission.service";
import {
  DetailedEventAnalysisComponent
} from "./single-event-analysis/views/detailed-event-analysis/detailed-event-analysis.component";
import {
  TimeSelectorViewComponent
} from "./time-performance-analysis-module/views/time-selector-view/time-selector-view.component";
import {
  TimeSeriesPerformanceTrackerViewComponent
} from "./time-performance-analysis-module/views/time-series-performance-tracker-view/time-series-performance-tracker-view.component";

export const ANALYTICS_ROUTES: Routes = [
    {
        path: AnalyticsRouting.EventPicker,
        component: EventSelectorViewComponent, pathMatch: 'full',
        outlet: 'analytics',
        canActivate: [AuthGuard], data: {roles: PermissionService.Permissions_SingleAnalyticsComponent().default}
    },
    {
        path: AnalyticsRouting.DetailedEventAnalysis,
        component: DetailedEventAnalysisComponent, pathMatch: 'full',
        outlet: 'analytics',
        canActivate: [AuthGuard], data: {roles: PermissionService.Permissions_SingleAnalyticsComponent().default}
    },
    {
        path: AnalyticsRouting.TimeSelectorView,
        component: TimeSelectorViewComponent, pathMatch: 'full',
        outlet: 'analytics',
        canActivate: [AuthGuard], data: {roles: PermissionService.Permissions_MultiAnalysisComponent().default}
    },
    {
        path: AnalyticsRouting.RevenuePerformanceTracker,
        component: TimeSeriesPerformanceTrackerViewComponent, pathMatch: 'full',
        outlet: 'analytics',
        canActivate: [AuthGuard], data: {roles: PermissionService.Permissions_MultiAnalysisComponent().default}
    }
]
